import { render, staticRenderFns } from "./CostCentres.vue?vue&type=template&id=d8828750&"
import script from "./CostCentres.vue?vue&type=script&lang=js&"
export * from "./CostCentres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports